import './personalForm.scss';

import _ from 'lodash';
import { connect } from 'react-redux';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import { translationFactory } from '../../global/i18nUtils.js';
import { getRecordTypeByGrade } from './utils.js';
import { PERSON_RECORD_TYPES, personRecordPropTypes } from '../record/global/addPersonV2Constants.js';
import { personPersonalFormPropTypes, personPersonalFormDefaultProps } from '../record/global/personFormPropTypes.js';
import Form from '../../global/form';
import PersonalFormActions from './personalFormActions.js';
import { resetData as resetDataContactForm } from './contactFormActions.js';
import { resetAvatar } from '../../global/avatarManagerActions.js';
import ModalPrompt from '../../global/modalPrompt.jsx';

const propTypes = {
    churchEntitiesList: PropTypes.arrayOf(
        PropTypes.shape({}),
    ).isRequired,
    className: PropTypes.string,
    excludeGradeByRecordType: personRecordPropTypes,
    isRecordTypeLabelEnabled: PropTypes.bool,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    personalFormData: personPersonalFormPropTypes,
    recordType: personRecordPropTypes,
    style: PropTypes.shape({}),
};

const defaultProps = {
    className: undefined,
    excludeGradeByRecordType: undefined,
    isRecordTypeLabelEnabled: false,
    onBlur: undefined,
    onFocus: undefined,
    personalFormData: personPersonalFormDefaultProps,
    recordType: 'adult',
    style: {},
};

const mapStateToProps = (state) => {
    const {
        global: {
            churchCampuses,
        },
        people: {
            addPerson: {
                personalForm: {
                    data: personalFormData,
                    recordType,
                },
            },
        },
    } = state;

    const churchEntitiesList = churchCampuses.getAllCampusesForSelect({
        includeNulls: true,
        excludeExtensions: true,
    });

    return {
        churchEntitiesList,
        personalFormData,
        recordType,
    };
};

const i18n = translationFactory();

class PersonalForm extends React.PureComponent {
    static onChangeBirthDate(value) {
        PersonalFormActions.updateBirthDate(value.date.unix());
    }

    static onChangeFirstName(value) {
        PersonalFormActions.updateFirstName(value);
    }

    static onChangeLastName(value) {
        PersonalFormActions.updateLastName(value);
    }

    static onChangeGender(value) {
        PersonalFormActions.updateGender(value);
    }

    static onChangeCampus(value) {
        PersonalFormActions.updateCampus(value);
    }

    constructor(props) {
        super(props);

        this.state = {
            isOpenRecordChangeTypeModal: false,
            selectedGrade: null,
        };

        this.onCancelRecordType = this.onCancelRecordType.bind(this);
        this.onChangeGrade = this.onChangeGrade.bind(this);
        this.onConfirmRecordTypeChange = this.onConfirmRecordTypeChange.bind(this);
    }

    componentDidMount() {
        PersonalFormActions.getChurchEntity();
    }

    componentWillUnmount() {
        PersonalFormActions.resetData();
    }

    onCancelRecordType() {
        this.setState({ isOpenRecordChangeTypeModal: false });
    }

    onChangeGrade(value) {
        const {
            recordType: previousRecordType,
        } = this.props;

        const {
            selectedGrade,
        } = this.state;
        const recordType = getRecordTypeByGrade(value);
        if (!_.isEmpty(selectedGrade) && !_.isEmpty(value) && previousRecordType !== recordType) {
            this.setState({
                isOpenRecordChangeTypeModal: true,
                selectedGrade: value,
            });
        } else {
            this.setState({
                selectedGrade: value,
            });
            PersonalFormActions.updateGrade(value);
            PersonalFormActions.updateRecordType(recordType);
        }
    }

    onConfirmRecordTypeChange() {
        const {
            selectedGrade,
        } = this.state;
        PersonalFormActions.resetData();
        resetDataContactForm();
        resetAvatar();
        const recordType = getRecordTypeByGrade(selectedGrade);
        PersonalFormActions.updateRecordType(recordType);
        PersonalFormActions.updateGrade(selectedGrade);
        this.setState({
            isOpenRecordChangeTypeModal: false,
        });
    }

    render() {
        const {
            churchEntitiesList,
            className,
            excludeGradeByRecordType,
            isRecordTypeLabelEnabled,
            onBlur,
            onFocus,
            personalFormData,
            recordType,
            style,
        } = this.props;

        const {
            isOpenRecordChangeTypeModal,
        } = this.state;

        const {
            birthDate,
            firstName,
            lastName,
            gender,
            grade,
            campus,
        } = personalFormData;

        const bemBlockName = 'person_add_personal_form';
        const bemBlockElementName = 'person_add_personal_form--field';
        const containerClasses = ClassNames(bemBlockName, className);

        const campusFieldProps = {
            options: churchEntitiesList,
        };

        const gradeFieldProps = {
            excludeGradeByRecordType,
            isRecordTypeLabelEnabled,
            recordType,
        };

        const birthDateFieldProps = {
            maxDate: moment(),
        };

        const isDateOfBirthRequired = (recordType === PERSON_RECORD_TYPES.child) ||
            (recordType === PERSON_RECORD_TYPES.student);

        return (
            <React.Fragment>
                <Form className={containerClasses} style={style}>
                    <Form.Fieldset
                        className={`${bemBlockName}--field_set`}
                        id={`${bemBlockName}--field_set`}
                        title={i18n('Personal')}
                    >
                        <Form.Field
                            className={`${bemBlockElementName}_firstname`}
                            fieldType="inputText"
                            label={i18n('FirstName')}
                            medium={6}
                            onBlur={() => onBlur('firstName', firstName)}
                            onFocus={() => onFocus('firstName', firstName)}
                            onChange={PersonalForm.onChangeFirstName}
                            required
                            value={firstName}
                        />
                        <Form.Field
                            className={`${bemBlockElementName}_lastname`}
                            fieldType="inputText"
                            label={i18n('LastName')}
                            medium={6}
                            onBlur={() => onBlur('lastName', lastName)}
                            onFocus={() => onFocus('lastName', lastName)}
                            onChange={PersonalForm.onChangeLastName}
                            required
                            value={lastName}
                        />
                        <Form.Field
                            className={`${bemBlockElementName}_birthdate`}
                            fieldType="inputDate"
                            fluid
                            label={i18n('Birthdate')}
                            fieldProps={birthDateFieldProps}
                            medium={6}
                            onChange={PersonalForm.onChangeBirthDate}
                            required={isDateOfBirthRequired}
                            value={birthDate}
                        />
                        <Form.Field
                            className={`${bemBlockElementName}_gender`}
                            fieldType="selectGender"
                            label={i18n('Gender')}
                            medium={6}
                            onChange={PersonalForm.onChangeGender}
                            value={gender}
                        />
                        <Form.Field
                            className={`${bemBlockElementName}_grade`}
                            fieldType="selectGrade"
                            fieldProps={gradeFieldProps}
                            fluid
                            label={i18n('Grade')}
                            medium={6}
                            onChange={this.onChangeGrade}
                            required
                            value={grade}
                        />
                        <Form.Field
                            className={`${bemBlockElementName}_campus`}
                            fieldType="select"
                            fieldProps={campusFieldProps}
                            fluid
                            label={i18n('Campus')}
                            medium={6}
                            onChange={PersonalForm.onChangeCampus}
                            required
                            value={campus}
                        />
                    </Form.Fieldset>
                </Form>
                <ModalPrompt
                    confirmBtnColor="warning"
                    confirmBtnLabel={i18n('Yes')}
                    isOpen={isOpenRecordChangeTypeModal}
                    onCancel={this.onCancelRecordType}
                    onClose={this.onCancelRecordType}
                    onConfirm={this.onConfirmRecordTypeChange}
                    subTitle={i18n('The grade selected will result in a different record type. Some of the data you entered may be lost. Are you sure you want to proceed?')}
                    title={i18n('Record Type Change')}
                />
            </React.Fragment>
        );
    }
}

PersonalForm.propTypes = propTypes;
PersonalForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(PersonalForm);
